import React from "react";
import DownloadUserLog from "../DownloadReport/userLog";

export default function HallTicketUserLog() {
  return (
    <DownloadUserLog apiPath="backoffice/hallticket" documentLabel="Hall Ticket" />
  );
}
